import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
const ProgressItem = ({ weight, color, totalWeight }) => {
  const percentage = weight > 0 ? ((weight / totalWeight) * 100).toFixed(2) : 0; // Calculate percentage
  return (
    <div
      className="progress-bar"
      style={{
        width: `${percentage}%`,
        backgroundColor: color,
        height: "15px", // Decreased height
        position: "relative", // Allow z-index to take effect
        zIndex: 1,
      }}
      // onMouseEnter={(e) => {
      //     e.currentTarget.style.zIndex = 2; // Bring to front on hover
      //     e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.3)";
      // }}
      // onMouseLeave={(e) => {
      //     e.currentTarget.style.zIndex = 1; // Reset z-index
      //     e.currentTarget.style.boxShadow = "none";
      // }}
    >
      {weight} {/* Display only the count */}
    </div>
  );
};

// ProgressBar Component
const ProgressBarLine = ({ progressItems }) => {
  const totalWeight = progressItems.reduce((sum, item) => sum + item.weight, 0);
  return (
    <div
      className="progress rounded"
      style={{ height: "15px", borderRadius: "5px" }}
    >
      {progressItems.map((item, index) => (
        <ProgressItem
          key={index}
          weight={item.weight}
          color={item.color}
          totalWeight={totalWeight}
        />
      ))}
    </div>
  );
};

// Legend Component
const Legend = ({ progressItems }) => {
  return (
    <div className="d-flex align-items-center justify-content-center mt-1 flex-wrap">
      {/* <h4 className="mr-3">Legends:</h4> */}
      {progressItems.map((item, index) => (
        <div key={index} className="d-flex align-items-center mr-4 mt-1">
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: item.color,
              borderRadius: "50%", // Rounded color box
              marginRight: "5px",
            }}
          ></div>
          <span className="font-weight-bold">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

// Example usage of ProgressBar
const ProgressBar = ({ progressItemsData }) => {
  const colorCode = [
    "#4caf50", // Green
    "#2196F3", // Blue
    "#ff9800", // Orange
    "#f44336", // Red
    "#9c27b0", // Purple
    "#00bcd4", // Cyan
    "#ffc107", // Amber
    "#8bc34a", // Light Green
    "#ff5722", // Deep Orange
    "#3f51b5", // Indigo
  ];

  const [progressItems, setProgressItems] = useState([]);

  useEffect(() => {
    if (progressItemsData !== undefined) {
      let progItem = [];
      progressItemsData.map((item, i) => {
        progItem.push({
          weight: item.value,
          color: colorCode[i],
          label: item.label,
        });
      });
      setProgressItems(progItem);
    }
  }, [progressItemsData]);

  return (
    <div className="container mt-1 w-100">
      <ProgressBarLine progressItems={progressItems} />
      <Legend progressItems={progressItems} />
    </div>
  );
};

export default ProgressBar;
